import { useContext } from "react";
import { GameContext } from "../context/GameContext";

export default function SubmitButton() {
  const { handleClickMergeLetters, error } = useContext(GameContext);
  return (
    <>
      <button
        onClick={handleClickMergeLetters}
        disabled={error ? true : false}
        className={`animate__bounceIn shadow-md block w-full p-4 mt-1 text-sm font-semibold text-white gradients rounded-3xl rounded ${
          error ? "btnDisabled" : ""
        }`}
      >
        Send
      </button>
    </>
  );
}
